






































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { UploadImage } from "@/request/tongue";
import {
  ComposeQuestion$,
  GetAllCates$,
  GetQuestionDetail$,
} from "@/request/jxgl";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../components/left-nav.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class XtkDetail extends Vue {
  private question: any = {
    question_id: "",
    题目名称: "",
    图片: "",
    题目类型: "单选题",
    题目难度: 1,
    cate_id: "",
    选项: [],
    正确答案: [],
  };
  private dialogImageUrl = "";
  private dialogVisible = false;
  private fileList: any[] = [];
  private limitedType: any = ".jpg,.jpeg,.png";
  private defaultValue: any = "";
  private cates: any[] = [];
  private tempCorrect: any[] = [];
  private index2Alpha: any[] = ["A", "B", "C", "D", "E", "F", "G", "H"];
  // 获得详情
  private fetchDetail() {
    const params: any = {
      params: {
        question_id: this.$route.query.id,
      },
    };
    GetQuestionDetail$(this, params).then((data: any) => {
      this.$set(this, "question", data);
      if (data["图片"]) {
        this.fileList.push({
          url: data["图片"],
          uid: new Date().getTime(),
          name: "图片.jpg",
        });
        this.$forceUpdate();
      }
      if (data["题目类型"] === "单选") {
        this.tempCorrect = [data["选项"][data["正确答案"][0]]];
      } else {
        data["选项"].forEach((item: any, index: any) => {
          const i = data["正确答案"].indexOf(index);
          if (i === -1) {
            this.tempCorrect.push(false);
          } else {
            this.tempCorrect.push(true);
          }
        });
      }
    });
  }
  // 获得分类列表
  private fetchCate() {
    GetAllCates$(this).then((data: any) => {
      this.cates = data;
    });
  }
  /**
   * @description 图片上传预处理
   */
  private beforeUpload(file) {
    const arr = file.name.split(".");
    const fileType = arr[arr.length - 1];
    if (this.limitedType.includes(fileType)) {
      return true;
    } else {
      this.$message.warning("只能上传特定类型的文件");
      return false;
    }
  }
  /**
   * @description 上传
   */
  private upload(d) {
    const uploadFilePath: any = "ds/file/" + d.file.name;
    const params: any = {
      type: "file",
      base64_image: "",
    };
    const reader = new FileReader();
    reader.readAsDataURL(d.file);
    reader.onload = (e: any) => {
      params["base64_image"] = e.target["result"];
      console.log(params);
      UploadImage(this, params).then((data: any) => {
        console.log(data);
        this.question["图片"] = data.image_url;
        this.fileList[0].url = data.image_url;
        console.log(this.fileList);
        this.$forceUpdate();
      });
    };
  }
  /**
   * @description 文件变化时
   */
  private handleFileChange(file, fileList) {
    this.fileList = fileList;
  }
  /**
   * @description 删除文件
   */
  private handleRemove(file) {
    this.fileList = [];
  }
  /**
   * @description 图片预览
   */
  private handlePictureCardPreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
  /**
   * @description 题目类型发生变化
   */
  private typeChange() {
    this.question["选项"] = [];
    this.tempCorrect = [];
  }
  // 增加一个选项
  private addItem() {
    if (this.question["选项"].length >= 6) {
      this.$message.warning("选项不能超过6个，请修改");
      return;
    }
    this.question["选项"].push("选项" + (this.question["选项"].length + 1));
    if (this.question["题目类型"] === "多选") {
      this.tempCorrect.push(false);
    }
  }
  // 删除一个选项
  private deleteThis(index) {
    this.question["选项"].splice(index, 1);
    if (this.question["题目类型"] === "多选") {
      this.tempCorrect.push(false);
    }
  }
  // 取消
  private cancel() {
    this.$router.back();
  }
  /**
   * @description 检查选项
   */
  private checkItem(event, index) {
    if (event.target.value === "" || !event.target.value === null) {
      this.$message.warning("选项名不能为空");
      this.$set(this.question["选项"], index, "选项" + (index + 1));
    }
  }
  // 保存
  private save() {
    if (!this.question["题目名称"]) {
      this.$message.warning("题目名称不能为空");
      return;
    }
    if (!this.question["cate_id"]) {
      this.$message.warning("分类不能为空");
      return;
    }
    if (this.question["选项"].length <= 1) {
      this.$message.warning("选项至少有两个");
      return;
    }
    if (this.question["题目类型"] === "单选") {
      if (!this.tempCorrect[0]) {
        this.$message.warning("请选择正确答案");
        return;
      }
      this.question["正确答案"] = [
        this.question["选项"].indexOf(this.tempCorrect[0]),
      ];
    } else {
      this.tempCorrect.forEach((item: any, index: any) => {
        if (item) {
          this.question["正确答案"].push(index);
        }
      });
      if (this.question["正确答案"].length <= 1) {
        this.$message.warning("请选择至少两个正确答案");
        return;
      }
    }
    // console.log(this.question);
    ComposeQuestion$(this, this.question).then((data: any) => {
      this.$message.success("编辑成功");
      this.$router.back();
    });
  }
  // 初始化
  private mounted() {
    this.fetchCate();
    if (this.$route.query.id) {
      this.fetchDetail();
    }
  }
}
